/**
 * Error code for when trying to upload multiple files.
 * @type {String}
 */
export const MULTIPLE_FILES_NOT_ALLOWED = 'MULTIPLE_FILES_NOT_ALLOWED';
/**
 * Error code for when trying to upload a folder.
 * @type {String}
 */
export const FOLDER_NOT_ALLOWED = 'FOLDER_NOT_ALLOWED';

/**
 * Error code for when trying to upload an incorrect file size.
 * @type {String}
 */
export const INCORRECT_FILE_SIZE = 'INCORRECT_FILE_SIZE';
/**
 * Error code for when trying to upload an incorrect file type.
 * @type {String}
 */
export const INCORRECT_FILE_TYPE = 'INCORRECT_FILE_TYPE';
/**
 * Error code for when no text is found in the image.
 * @type {String}
 */
export const NO_DATA_FOUND_FOR_IMAGE_ERROR = 'NO_DATA_FOUND_FOR_IMAGE_ERROR';
/**
 * Error code for when the auto recognition process is cancelled.
 * @type {String}
 */
export const CANCELED_AUTO_RECOGNITION_ERROR = 'CANCELED_AUTO_RECOGNITION_ERROR';
/**
 * Error code for when results request returns an error.
 * @type {String}
 */
export const REQUEST_RESULTS_ERROR = 'REQUEST_RESULTS_ERROR';
/**
 * Error code for when bad results are shown (vertical image or no text selected).
 * @type {String}
 */
export const BAD_RESULTS_ERROR = 'BAD_RESULTS_ERROR';
/**
 * Default error code.
 * @type {String}
 */
export const DEFAULT = 'DEFAULT';
/**
 * No error.
 * @type {String}
 */
export const NO_ERROR = '';



// WEBPACK FOOTER //
// ./src/constants/errorConstants.js